window.togglePasswordVisibility = (form) => {
    let $form = $(form);

    if ($form.hasClass('password-visible')) {
        $form.find('input.password').attr('type', 'password').toggleClass('password');
        $form.find('.fa.fa-eye-slash').removeClass('fa-eye-slash').addClass('fa-eye')
    } else {
        $form.find('input[type=password]').attr('type', 'text').toggleClass('password');
        $form.find('.fa.fa-eye').removeClass('fa-eye').addClass('fa-eye-slash')
    }
    $form.toggleClass('password-visible');
};

window.subscribeToNewsletter = (e) => {
    e.preventDefault();

    let $form = $(e.target);

    $form.find('input[name="email"]').removeClass('is-invalid').removeClass('is-failed');
    $form.find('.valid-feedback').removeClass('d-block').find('strong').html('');
    $form.find('.invalid-feedback').removeClass('d-block').find('strong').html('');

    $form.find('.fa-spin').toggleClass('d-none');
    $form.find('.fa-envelope').toggleClass('d-none');
    $form.find('button[type=submit]').attr('disabled', true);

    window.axios.post($form.attr('action'), $form.serialize())
    .then((res) => {
        $form.find('input[name="email"]').addClass('is-valid');
        $form.find('.valid-feedback').addClass('d-block').find('strong').html("Super !!!");
    })
    .catch((err) => {
        let errors = err.response.data.errors;
        for(let i in errors){
            if(i=='email'){
                $form.find('input[name="email"]').addClass('is-invalid');
                $form.find('.invalid-feedback').addClass('d-block').find('strong').html(errors[i]);
            }
        }
    }).finally(()=>{
        $form.find('.fa-spin').toggleClass('d-none');
        $form.find('.fa-envelope').toggleClass('d-none');
        $form.find('button[type=submit]').attr('disabled', false);
    })
};
